import dayjs from 'dayjs'

export type ICalendarDate = [number, number, number, number, number]

export interface CreateEventParams {
  title: string
  start: dayjs.Dayjs
  duration: number
  recurrenceId?: string
}

export interface ICalendarEvent {
  uid: string
  title: string
  start: ICalendarDate
  duration: {
    hours: number
    minutes: number
  }
  recurrenceId?: string
  recurrenceRule?: string
  exceptionDates?: ICalendarDate[]
  status: string
  busyStatus: string
  created: ICalendarDate
}

export const enum ICalendarWeekday {
  MO = 'MO',
  TU = 'TU',
  WE = 'WE',
  TH = 'TH',
  FR = 'FR',
  SA = 'SA',
  SU = 'SU',
}

export interface ICalendarEventInMap {
  type: 'single' | 'daily' | 'weekly' | 'monthlyByDay' | 'monthlyByWeek' | 'yearlyByDate' | 'yearlyByWeek'
  event: ICalendarEvent
  interval?: number
}
export const enum PeriodMode {
  ONCE = 'once',
  EVERY_DAY = 'everyDay',
  EVERY_WORK_DAY = 'everyWorkDay',
  EVERY_SPECIAL_MONTH_DAY = 'everySpecialMonthDay',
  EVERY_SPECIAL_WEEK_DAY = 'everySpecialWeekDay',
}
